import { Injectable } from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { isNullOrUndefined } from 'util';

@Injectable()
export class DespachoDevolverService {

  apiService: any;

  constructor() { }

  devolver(vm, dados) {
    dados.data_andamento = vm.dataHoraDoSistema;
    return true;
  }
}


// WEBPACK FOOTER //
// ./src/app/services/despachoDevolver.service.ts